import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PWAData.css'
import baseURL from '../../url';

export default function PWAData() {
    const [configuracion, setConfiguracion] = useState({});
    const [nombreApp, setNombreApp] = useState('');
    const [activo, setActivo] = useState(1);
    const [logo, setLogo] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        cargarConfiguracion();
    }, []);

    useEffect(() => {
        if (configuracion) {
            setNombreApp(configuracion.nombreApp || 'Mi App');
            setActivo(configuracion.activo !== undefined ? configuracion.activo : 1);
        }
    }, [configuracion]);

    const cargarConfiguracion = () => {
        fetch(`${baseURL}/pwaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setConfiguracion(data.pwa || {});
            })
            .catch(error => console.error('Error al cargar configuración PWA:', error));
    };

    const handleUpdateText = () => {
        if (!nombreApp || nombreApp.trim() === '') {
            toast.error('El nombre de la aplicación no puede estar vacío');
            return;
        }

        const payload = {
            nombreApp: nombreApp || configuracion.nombreApp || 'Mi App',
            activo: activo
        };

        fetch(`${baseURL}/pwaPut.php`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error!', data.error, 'error');
                } else {
                    Swal.fire('¡Guardado!', data.mensaje, 'success');
                    cargarConfiguracion();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const previewURL = URL.createObjectURL(file);
            setLogo(file);
            setLogoPreview(previewURL);
        }
    };

    const handleEditarImagen = () => {
        const formData = new FormData();

        if (logo) {
            formData.append('logo', logo);
        } else {
            toast.error('Selecciona un logo');
            return;
        }

        fetch(`${baseURL}/pwaImagePut.php`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                } else {
                    Swal.fire({
                        title: '¡Logo actualizado!',
                        html: data.mensaje + '<br><br><strong>Importante:</strong> Los usuarios que ya instalaron la app deben desinstalarla y reinstalarla para ver el nuevo logo.<br><br>El nuevo logo se verá automáticamente en nuevas instalaciones.',
                        icon: 'success',
                        confirmButtonColor: '#DAA520'
                    });
                    // Limpiar caché del navegador para el manifest
                    if ('caches' in window) {
                        caches.keys().then(function(names) {
                            for (let name of names) {
                                caches.delete(name);
                            }
                        });
                    }
                    cargarConfiguracion();
                    setLogo(null);
                    setLogoPreview(null);
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const abrirModal = () => {
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    return (
        <div>
            
            <div className='pwaContainer'>
                <h2>Configuración PWA (Progressive Web App)</h2>
                <p>Gestiona la configuración de tu aplicación web progresiva</p>
                
                <div className='pwaInfoCard'>
                    <div className='pwaInfoRow'>
                        <strong>Nombre de la App:</strong>
                        <span>{configuracion.nombreApp || 'Sin configurar'}</span>
                    </div>
                    <div className='pwaInfoRow'>
                        <strong>Estado:</strong>
                        <span className={configuracion.activo === 1 ? 'estadoActivo' : 'estadoInactivo'}>
                            {configuracion.activo === 1 ? 'Activo ✓' : 'Inactivo'}
                        </span>
                    </div>
                    <div className='pwaInfoRow'>
                        <strong>Logo:</strong>
                        {configuracion.logo ? (
                            <img src={configuracion.logo} alt="Logo PWA" className='logoMiniatura' />
                        ) : (
                            <span style={{color: '#999', fontStyle: 'italic'}}>Sin logo configurado</span>
                        )}
                    </div>
                </div>

                {(!configuracion.nombreApp || configuracion.idConfiguracion === 0) && (
                    <div style={{
                        backgroundColor: '#fff3cd', 
                        color: '#856404', 
                        padding: '12px 16px', 
                        borderRadius: '6px', 
                        marginBottom: '15px',
                        border: '1px solid #ffeaa7'
                    }}>
                        ℹ️ No hay configuración PWA. Haz clic en "Editar Configuración PWA" para crear la configuración inicial.
                    </div>
                )}

                <div style={{
                    backgroundColor: '#e3f2fd', 
                    color: '#1565c0', 
                    padding: '12px 16px', 
                    borderRadius: '6px', 
                    marginBottom: '15px',
                    border: '1px solid #90caf9',
                    fontSize: '13px'
                }}>
                    <strong>💡 Nota importante:</strong> Cuando cambies el logo del PWA, los usuarios que ya tienen la app instalada necesitarán desinstalarla y reinstalarla para ver el nuevo logo. Las nuevas instalaciones mostrarán el logo actualizado automáticamente.
                </div>

                <button className='btnPost' onClick={abrirModal}>
                    Editar Configuración PWA
                </button>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Configuración General
                                </button>
                                <button
                                    className={selectedSection === 'imagen' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagen')}
                                >
                                    Editar Logo
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre de la Aplicación</legend>
                                    <input
                                        type="text"
                                        value={nombreApp}
                                        onChange={(e) => setNombreApp(e.target.value)}
                                        placeholder="Ej: Nombre del Hospedaje App"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado de PWA</legend>
                                    <select 
                                        value={activo} 
                                        onChange={(e) => setActivo(parseInt(e.target.value))}
                                    >
                                        <option value={1}>Activo</option>
                                        <option value={0}>Inactivo</option>
                                    </select>
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={handleUpdateText}>Guardar Cambios</button>
                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagen' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>
                                {logoPreview ? (
                                    <img src={logoPreview} alt="Vista previa del logo" />
                                ) : (
                                    <>
                                        {configuracion.logo ? (
                                            <img src={configuracion.logo} alt="Logo actual" />
                                        ) : (
                                            <span className='imgNone'>
                                                No hay logo configurado
                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Subir Logo (512x512px recomendado)</legend>
                                <input type="file" accept="image/*" onChange={handleFileChange} />
                            </fieldset>
                            <button className='btnPost' onClick={handleEditarImagen}>Guardar Logo</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

